<template>
    <div class="selectores-container">
      <div class="selector" :style="{'animation-delay': ((index*200)+1000)+'ms'}" v-for="(area, index) in areas_curriculares" :key="index">
        <div class="selector-circle" :style="{'border-color': area.color, 'border-right-color': 'rgba(255, 255, 255, 0.3)'}" :class="{seleccionado: area.seleccionado}" @click="filtrar(area)">
          <span>{{area.abrev}}</span>
        </div>
        <div class="selector-texto">
          <div class="selector-titulo">
            <h1>{{area.nombre}}</h1>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import _ from "lodash"
export default {
  name: 'Selectores',
  props: ['eventBus', 'areas_curriculares'],
  components: {},
  data: function(){
      return { }
  },
  computed:{},
  methods: {
    filtrar(area){
      this.$emit('filtrar', area)
    },
  },
  created(){},
  mounted(){}
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/responsiveness.scss";
  .selectores-container{
    z-index: 1;
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: auto;
    height: auto;
    // background-color: gray;
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap-reverse;
    width: 900px;
    max-width: 70%;
    @include tablet-m {
      // width: 900px;
      max-width: 100%;
    }
    @include mobile {
      width: auto;
      max-width: unset;
      flex-direction: column;
      flex-wrap: nowrap;
      z-index: 2;
      height: 100%;
      justify-content: center;
    }
  }

  .selector{
    opacity: 0;
    animation: fade 500ms ease-in-out forwards;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 150px;
    height: 60px;
    padding: 10px;
    color: white;
    text-shadow: 0px 0px 3px black;
    @include tablet-m {
      height: 50px;
      padding: 5px;
    }
    @include mobile {
      width: auto;
      height: 40px;
      padding: 10px;
      position: relative;
    }
  }

  .selector-circle{
    width: 60px;
    height: 60px;
    // background-color: aqua;
    border-radius: 50%;
    margin: 10px;
    box-sizing: border-box; 
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: url('~@/assets/img/cursors/pointer.png'), pointer;
    // flex-grow: 1;
    flex-shrink: 0;
    font-size: 20pt;
    font-weight: 400;
    border: 6px solid rgb(0, 89, 255);
    border-right: 6px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0px 0px 2px black;
    @include tablet-m {
      width: 50px;
      height: 50px;
    }
    @include mobile {
      width: 40px;
      height: 40px;
      font-size: 15pt;
      margin: 5px;
    }
  }

  .selector-circle.seleccionado{
    // background-color: lightseagreen;
    transform: scale(1);
    color: rgb(160, 255, 160);
    // box-shadow: 0px 0px 10px 0px rgb(118, 255, 118);
    @include mobile {
      transform: scale(1);
    }
  }

  // .selector-circle.seleccionado::before{
  //   content: '';
  //   position: absolute;
  //   // top: 0px;
  //   // left: 0px;
  //   width: 50px;
  //   height: 50px;
  //   border-radius: 50%;
  //   // margin: 10px;
  //   box-sizing: border-box;
  //   border: 6px solid rgb(0, 89, 255);
  //   // border-right: 6px solid rgba(255, 255, 255, 0.3);
  // }

  .selector-circle.seleccionado::after{
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: rgb(94, 253, 94);
    box-shadow: 0px 0px 3px 0px rgb(118, 255, 118);
    position: absolute;
    right: calc(100% + 10px);
  }

  .selector-texto{
    text-align: left;
    // overflow-x: hidden;
    // overflow-y: hidden;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    @include mobile {
      visibility: hidden;
      transition: visibility 0ms linear 500ms, opacity 500ms;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.6);
      right: 70px;
      border-radius: 15px;
      max-width: 180px;
      height: 50px;
      padding: 6px;
      box-sizing: border-box;
      opacity: 0;
    }
  }

  .selector:hover > .selector-texto{
    visibility:visible;
    opacity: 1;
    transition-delay:0s;
  }

  .selector-titulo{
    flex-grow: 1;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    max-width: 100%;
    // overflow: hidden;
    // white-space: pre-wrap;
    // text-overflow: ellipsis;
  }
  .selector-texto-cuerpo{
    flex-grow: 0;
    flex-shrink: 1;
    overflow-x: hidden;
    overflow-y: auto;
    @include mobile {
      display: none;
    }
  }

  .selector-texto h1{
    font-weight: 600;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }

  .selector-texto h1, .selector-texto p{
    font-size: 11pt;
    padding: 0px;
    margin: 0px;
  }

  @keyframes fade {
    0% { opacity: 0; transform: translateY(50px) }
    100% { opacity: 1; transform: translateY(0px) }
  }
</style>
